import { Button } from '../../components/ui';
import { SectionCard } from '../../components/trainer/SectionCard';

interface UpcomingAssignmentSummary {
  id: string;
  clientName: string;
  workoutName: string;
  scheduledFor: string;
  status: string;
}

interface UpcomingSessionsProps {
  assignments: UpcomingAssignmentSummary[];
  totalAssignments: number;
  onViewAllSessions: () => void;
}

export function UpcomingSessions({
  assignments,
  totalAssignments,
  onViewAllSessions,
}: UpcomingSessionsProps) {
  return (
    <SectionCard
      eyebrow="Schedule"
      title="Upcoming Sessions"
      action={
        <Button variant="ghost" size="sm" onClick={onViewAllSessions}>
          View sessions
        </Button>
      }
      fillHeight
    >
      {assignments.length > 0 ? (
        <div className="space-y-3">
          {assignments.map((assignment) => (
            <div
              key={assignment.id}
              className="rounded-xl border border-gray-200 bg-white/60 px-4 py-3 dark:border-white/10 dark:bg-white/5"
            >
              <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                <div>
                  <p className="font-medium text-gray-900 dark:text-white">{assignment.workoutName}</p>
                  <p className="text-sm text-gray-600 dark:text-slate-400">{assignment.clientName}</p>
                </div>
                <div className="sm:text-right">
                  <p className="text-sm font-medium text-gray-900 dark:text-white">{assignment.scheduledFor}</p>
                  <p className="text-xs uppercase tracking-wide text-gray-600 dark:text-slate-400">
                    {assignment.status.replace('_', ' ')}
                  </p>
                </div>
              </div>
            </div>
          ))}
          <p className="text-xs text-gray-600 dark:text-slate-400">{totalAssignments} total assignments across your roster.</p>
        </div>
      ) : (
        <div className="rounded-xl border border-dashed border-gray-300 px-4 py-6 text-center text-sm text-gray-600 dark:border-white/10 dark:text-slate-400">
          No upcoming sessions scheduled yet.
        </div>
      )}
    </SectionCard>
  );
}
